<template>
  <section class="fl-hero">
    <div class="container">
      <!-- Brand row: same on every page -->
      <div class="d-flex align-items-center">
        <h1 class="text-white lh1 mb0">FORTified Learning</h1>
        <div class="mlauto">
          <slot name="actions" />
        </div>
      </div>

      <p class="fl-tagline">
        Sharpen your Spacesaver solutions knowledge and ability to leverage the
        right solution in any sales scenario.
      </p>

      <!-- Section tabs: admins only -->
      <nav
        v-if="visibleTabs.length"
        class="fl-tabs"
        aria-label="FORTified Learning sections"
      >
        <router-link
          v-for="tab in visibleTabs"
          :key="tab.to"
          :to="tab.to"
          class="fl-tab"
          :class="{ 'fl-tab--active': isActive(tab) }"
        >
          <span class="material-icons">{{ tab.icon }}</span>
          {{ tab.label }}
        </router-link>
      </nav>

      <!-- Page-specific content: stats, search, award form, etc. -->
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "FortHero",
  props: {
    // Pass your existing TrainingAdmin value: <FortifiedHero :admin="TrainingAdmin">
    admin: { type: Boolean, default: false },
  },
  data() {
    return {
      tabs: [
        { label: "Courses", icon: "school", to: "/fortified-learning", exact: true, external: true},
        { label: "Completions", icon: "fact_check", to: "/fortified-learning/admin/completions", external: true },
        { label: "Enroll", icon: "group_add", to: "/fortified-learning/admin/enroll", external: true },
        { label: "Credits", icon: "emoji_events", to: "/fortified-learning/admin/credits", external: false },
        // { label: "Certification", icon: "verified_user", to: "/fortified-learning/admin/certification", external: false },
      ],
    };
  },
  methods: {
    isActive(tab) {
      const path = this.$route.path.replace(/\/$/, "");
      return tab.exact ? path === tab.to : path.startsWith(tab.to);
    },
  },
  computed: {
    TrainingAdmin() {
			return this.$store.getters.isTrainingAdmin;
		},
    InternalTrainingAdmin() {
      return this.$store.getters.isInternalTrainingAdmin;
    },
    visibleTabs() {
      return this.tabs.filter((tab) =>
        tab.external ? this.TrainingAdmin : this.InternalTrainingAdmin
      );
    },
  }
};
</script>

<style scoped>
.fl-hero {
  padding: 30px 0 0;
}
.fl-tagline {
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.3;
  margin: 8px 0;
}
.fl-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.fl-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  color: rgba(255, 255, 255, 0.75);
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
  text-decoration: none;
  font-weight: 400;
}
.fl-tab .material-icons {
  font-size: 18px;
}
.fl-tab:hover {
  color: #fff;
  text-decoration: none;
}
.fl-tab--active {
  color: #fff;
  border-bottom-color: #429da8;
  font-weight: 500;
}
</style>
